// IntelliBPO Site Data — Exact match to live site

export const siteConfig = {
  name: "IntelliBPO",
  tagline: "Skilled People. Dedicated to Your Business.",
  description: "Driving desirable business outcomes through skilled people and smart technology.",
  contact: {
    phone: "+27(0)87 049 5570",
    email: "hello@intellibpo.com",
  },
  social: {
    linkedin: "https://linkedin.com/company/intellibpo",
    twitter: "https://twitter.com/intellibpo",
    facebook: "https://facebook.com/intellibpo",
    instagram: "https://instagram.com/intellibpo",
  },
};

export const topStripServices = [
  "Customer Support - In & Outbound",
  "Medical Billing",
  "Virtual Assistant / Back Office Support",
  "Sales & Lead Generation",
  "Debt Collection",
  "Data Analysis / Entry",
  "Technical Support",
  "Specialised High-Level Recruitment",
];

export const navigation = [
  { name: "HOME", href: "/" },
  { name: "ABOUT US", href: "/our-story" },
  {
    name: "SERVICES",
    href: "/our-services",
    children: [
      { name: "Customer Support - In & Outbound", href: "/our-services/customer-support" },
      { name: "Healthcare Billing Support", href: "/our-services/healthcare-billing" },
      { name: "Virtual Assistant / Back Office Support", href: "/our-services/virtual-assistant" },
      { name: "Sales & Lead Generation", href: "/our-services/sales-lead-generation" },
      { name: "Debt Collection", href: "/our-services/debt-collection" },
      { name: "Data Analysis / Entry", href: "/our-services/data-analysis" },
      { name: "Technical Support", href: "/our-services/technical-support" },
      { name: "Specialised High-Level Recruitment", href: "/our-services/recruitment" },
    ],
  },
  { name: "SECTORS", href: "/industries" },
  { name: "CASE STUDIES", href: "/case-studies" },
  { name: "CAREERS", href: "/careers" },
  { name: "BLOG / VLOG", href: "/vlogs" },
];

export const stats = [
  { value: "500+", label: "Employees", icon: "stat-employees" },
  { value: "3 Major Hubs", label: "Johannesburg, Durban, Cape Town", icon: "stat-hubs" },
  { value: "<5%", label: "Agent Attrition Rate", icon: "stat-attrition" },
  { value: "25+ Years", label: "Industry Experience", icon: "stat-experience" },
];

export const services = [
  {
    id: "customer-support",
    title: "CUSTOMER SUPPORT",
    description: "Friendly, empathetic and patient agents who become the voice between your company and your customers — handling calls, emails and chats with care.",
    icon: "service-cx",
    href: "/services/customer-support",
  },
  {
    id: "healthcare-billing",
    title: "HEALTHCARE BILLING SUPPORT",
    description: "Detail-oriented, reliable people who take the complexity out of claims follow-ups, billing queries and accounts receivable so nothing falls through the cracks.",
    icon: "service-healthcare",
    href: "/services/healthcare-billing",
  },
  {
    id: "virtual-assistant",
    title: "VIRTUAL ASSISTANTS",
    description: "Organised, proactive assistants who keep your calendar, inbox and operations running smoothly — so you can focus on growing your business.",
    icon: "service-va",
    href: "/services/virtual-assistant",
  },
  {
    id: "sales",
    title: "SALES & LEAD GENERATION",
    description: "Confident, persuasive people who know how to start conversations, qualify leads and turn prospects into paying customers.",
    icon: "service-sales",
    featured: true,
    href: "/services/sales",
  },
  {
    id: "debt-collection",
    title: "DEBT COLLECTION & RECOVERY",
    description: "Firm but respectful agents trained in compliant recovery techniques — recovering what's owed while protecting your brand reputation.",
    icon: "service-debt",
    href: "/services/debt-collection",
  },
  {
    id: "data-analysis",
    title: "DATA ANALYSIS & ENTRY",
    description: "Accurate, methodical people who clean, organise and make sense of your data — turning numbers into decisions you can act on.",
    icon: "service-data",
    href: "/services/data-analysis",
  },
  {
    id: "technical-support",
    title: "TECHNICAL SUPPORT",
    description: "Patient, knowledgeable troubleshooters who guide your users through issues quickly — reducing tickets and keeping satisfaction high.",
    icon: "service-tech",
    href: "/services/technical-support",
  },
  {
    id: "recruitment",
    title: "SPECIALIST RECRUITMENT",
    description: "Experienced recruiters who find and place top-tier talent for hard-to-fill and senior-level roles — fast, thorough and right first time.",
    icon: "service-recruitment",
    href: "/services/recruitment",
  },
];

export const saCards = [
  {
    title: "Western Market Alignment",
    description: "First-language English speakers with neutral accents and deep understanding of US, UK, European, and Australian business environments.",
  },
  {
    title: "Time Zone Compatibility",
    description: "Well positioned to support European and UK business hours, with the operational flexibility to deliver true 24/7 coverage for US-based clients.",
  },
  {
    title: "Enterprise-Grade Infrastructure",
    description: "Our delivery hubs in Johannesburg, Durban, and Cape Town are supported by secure facilities, redundant connectivity, and the infrastructure required for reliable, uninterrupted operations.",
  },
];

export const deliveryMetrics = {
  topCards: [
    { value: "92%", label: "Candidate Approval Rate", image: "candidate-approval" },
    { value: "94%", label: "Training Success Rate", image: "training-success" },
    { value: "90%", label: "Productivity Rate", image: "productivity" },
    { value: "86%", label: "Training Net Promoter Score", image: "nps" },
  ],
  kpiBars: [
    { label: "Customer Satisfaction", value: 95, image: "bar1" },
    { label: "KPI Adherence", value: 91, image: "bar2" },
    { label: "Employee Productivity", value: 95, image: "bar3" },
    { label: "Agent Attrition", value: 5, image: "bar4", inverted: true },
  ],
};

export const testimonials = [
  {
    quote: "Working with IntelliBPO has significantly improved the efficiency of our operational processes. Their team understands the importance of compliance, documentation, and structured reporting. The level of professionalism and accountability they bring gives us complete confidence in the services they deliver.",
    author: "Managing Director",
    company: "Compliance Advisory Firm",
    flag: "🇺🇸",
  },
  {
    quote: "IntelliBPO helped us streamline customer support and back-office operations while maintaining high service standards. Their ability to provide dedicated teams aligned to our business has allowed us to scale efficiently while maintaining strong operational visibility and performance.",
    author: "Vice President of Operations",
    company: "Medical Supply Company",
    flag: "🇺🇸",
  },
  {
    quote: "Our business requires consistent customer support across multiple time zones, and IntelliBPO delivered exactly that. Their team integrates seamlessly with our operations, providing reliable support backed by clear performance reporting and operational accountability.",
    author: "Chief Technology Officer",
    company: "Global Tech Support Company",
    flag: "🇬🇧",
  },
  {
    quote: "IntelliBPO quickly became an extension of our operations team. Their structured approach to healthcare collections and administrative support improved our recovery performance while reducing the pressure on our internal staff. The professionalism and operational oversight they bring has made them a trusted long-term partner for our organisation.",
    author: "Chief Operating Officer",
    company: "Large US Dermatology Group",
    flag: "🇺🇸",
  },
  {
    quote: "Accuracy, speed, and reliability are critical in our industry. IntelliBPO delivered dedicated teams that integrated seamlessly with our workflows, allowing us to scale our operations while maintaining strict turnaround requirements. Their reporting and operational discipline have had a direct impact on our efficiency.",
    author: "Director of Operations",
    company: "Medical Records Retrieval Company",
    flag: "🇦🇺",
  },
];

export const contactLocations = [
  {
    city: "Johannesburg, Gauteng",
    address: "3rd Floor, 26 Girton Road, Parktown, Johannesburg",
  },
  {
    city: "Durban, KwaZulu-Natal",
    address: "1D Umhlanga Boulevard, 1 Lunar Row, New Town Centre Umhlanga KZN",
  },
  {
    city: "Cape Town, Western Cape",
    address: "1st Floor Eagle House, 39 Somerset Road, De Waterkant",
  },
];

export const footerLinks = {
  services: [
    { name: "Customer Support - In & Outbound", href: "/our-services#customer-support" },
    { name: "Healthcare Billing Support", href: "/our-services#healthcare-billing" },
    { name: "Virtual Assistant / Back Office Support", href: "/our-services#virtual-assistant" },
    { name: "Sales & Lead Generation", href: "/our-services#sales" },
    { name: "Debt Collection", href: "/our-services#debt-collection" },
    { name: "Data Analysis / Entry", href: "/our-services#data-analysis" },
    { name: "Technical Support", href: "/our-services#technical-support" },
    { name: "Specialised High-Level Recruitment", href: "/our-services#recruitment" },
  ],
  contact: [
    { name: "Johannesburg", href: "/contact" },
    { name: "Durban", href: "/contact" },
    { name: "Cape Town", href: "/contact" },
    { name: "Blog / Vlog", href: "/vlogs" },
    { name: "+27(0) 87 049 5570", href: "tel:+27870495570" },
    { name: "hello@intellibpo.com", href: "mailto:hello@intellibpo.com" },
  ],
  legal: [
    { name: "Terms of Use", href: "/terms" },
    { name: "Privacy Policy", href: "/privacy" },
  ],
};

export const caseStudies = [
  {
    slug: "medical-document-retrieval",
    title: "Medical Document Retrieval Services",
    client: "Leading North American Healthcare Company",
    industry: "Healthcare",
    region: "United States of America",
    flag: "🇺🇸",
    summary: "Scaled from 15 to 142 agents to manage surging volumes while improving KPIs and turnaround times.",
    highlights: [
      { bold: "A leading North American company in medical document retrieval services", text: " experienced surges in volumes and which caused challenges with KPIs in their business processes." },
      { bold: "IntelliBPO was initially appointed to provide 15 skilled customer service agents", text: " to engage with various service providers on behalf of the client and has since grown the team to 142." },
      { bold: "We assisted to curtail delayed turnaround and quality requirements", text: " whilst building solid analytics and insights around the client processes." },
      { bold: "The campaign is in its 5th year of operation.", text: "" },
    ],
    challenge: "A leading North American company in medical document retrieval services experienced surges in volumes which caused challenges with KPIs in their business processes. They needed a partner who could scale rapidly while maintaining quality standards.",
    solution: "IntelliBPO was initially appointed to provide 15 skilled customer service agents to engage with various service providers on behalf of the client. We assisted to curtail delayed turnaround and quality requirements whilst building solid analytics and insights around the client processes.",
    results: ["Team grew from 15 to 142 agents", "5th year of operation", "Improved turnaround times", "Enhanced quality requirements", "Solid analytics and insights delivered"],
  },
  {
    slug: "australian-industrial-supplies",
    title: "Industrial Supplies Distribution",
    client: "Leading Australian Industrial Supplies Company",
    industry: "Retail & Distribution",
    region: "Australia",
    flag: "🇦🇺",
    summary: "Deployed 10 skilled agents to introduce new products and establish critical customer contact, improving sales and customer experience.",
    highlights: [
      { bold: "Leading Australian company that distributes industrial supplies", text: " on a national level introduced new products into its extensive client base." },
      { bold: "IntelliBPO was appointed to provide 10 skilled customer service agents", text: " to communicate with clients and leverage the engagement as a means to introduce new products and establish critical contact with customers." },
      { bold: "IntelliBPO assisted the client to improve/increase", text: " sales and improve the customer experience." },
      { bold: "The campaign is in its 3rd year of operation", text: " and keeps growing from strength to strength." },
    ],
    challenge: "A leading Australian company that distributes industrial supplies on a national level needed support introducing new products into its extensive client base while maintaining customer relationships.",
    solution: "IntelliBPO was appointed to provide 10 skilled customer service agents to communicate with clients and leverage the engagement as a means to introduce new products and establish critical contact with customers.",
    results: ["Improved sales performance", "Enhanced customer experience", "3rd year of operation", "Continuous growth trajectory"],
  },
  {
    slug: "american-dermatology-group",
    title: "Dermatology Group Patient Services",
    client: "Leading American Dermatology Group",
    industry: "Healthcare",
    region: "United States of America",
    flag: "🇺🇸",
    summary: "Grew from 15 to 83 agents managing appointment scheduling, patient interactions, and general enquiries across multiple practices.",
    highlights: [
      { bold: "A leading American Dermatology Group", text: " launched an aggressive acquisition strategy and was looking for a partner to manage appointment scheduling, patient interactions with the various practices/offices and general enquiries." },
      { bold: "IntelliBPO was contracted to provide 15 skilled customer service agents.", text: " After 2 years this grew to a team of 83 as more medical practices have been acquired while growing each month." },
      { bold: "IntelliBPO assisted the client", text: " to significantly increase revenue and productivity through its efficient (AI enabled) and customer-centric services." },
    ],
    challenge: "A leading American Dermatology Group launched an aggressive acquisition strategy and needed a partner to manage appointment scheduling, patient interactions with the various practices/offices, and general enquiries across a growing network of medical practices.",
    solution: "IntelliBPO was contracted to provide 15 skilled customer service agents. Through efficient, AI-enabled and customer-centric services, we helped the client significantly increase revenue and productivity as their practice network expanded.",
    results: ["Team grew from 15 to 83 agents", "Significant revenue increase", "AI-enabled service delivery", "Growing each month with new acquisitions"],
  },
  {
    slug: "compliancy-group-hotlines",
    title: "Compliancy Group Hotline Management",
    client: "Leading Compliancy Group",
    industry: "Professional Services",
    region: "United States of America",
    flag: "🇺🇸",
    summary: "Scaled from 15 to 100 agents managing compliance hotlines across multiple industries and time zones, achieving the highest KPI scores.",
    highlights: [
      { bold: "A leading Compliancy Group required a partner to manage its clients' hotlines", text: " across multiple industries and time zones." },
      { bold: "IntelliBPO was contracted to provide 15 skilled customer service agents", text: ". After 15 months this has grown to a team of 100 as more volumes were directed to IntelliBPO from other near-shore centers." },
      { bold: "IntelliBPO's agents have achieved the highest KPI scores", text: " and other performance indicators compared to other BPOs servicing the client." },
    ],
    challenge: "A leading Compliancy Group required a partner to manage its clients' hotlines across multiple industries and time zones. They needed a reliable outsourcing partner who could deliver consistent quality at scale.",
    solution: "IntelliBPO was contracted to provide 15 skilled customer service agents to manage compliance hotlines. After 15 months, the team grew to 100 as more volumes were directed to IntelliBPO from other near-shore centers due to our superior performance.",
    results: ["Team grew from 15 to 100 agents", "Highest KPI scores vs other BPOs", "Multi-industry hotline coverage", "Volumes redirected from other near-shore centers"],
  },
];

export const resources = [
  {
    slug: "south-africa-outsourcing-guide",
    title: "The Complete Guide to Outsourcing to South Africa",
    type: "Guide",
    summary: "Everything you need to know about leveraging South African talent for your business.",
    date: "2024-01-15",
  },
  {
    slug: "agent-retention-strategies",
    title: "Agent Retention: How We Maintain <5% Attrition",
    type: "Case Study",
    summary: "Learn the strategies behind our industry-leading retention rates.",
    date: "2024-02-20",
  },
  {
    slug: "hipaa-compliance-outsourcing",
    title: "HIPAA Compliance in Offshore Medical Billing",
    type: "Whitepaper",
    summary: "A comprehensive look at maintaining compliance while outsourcing medical billing.",
    date: "2024-03-10",
  },
];
